window.initGeneralReport = () => {
  const personalReport = (employeeId) => {
    $(".report-instance-selector").val(employeeId).trigger("change");
  };

  $("#instances_info_table .general-table-name").on("click", function () {
    personalReport($(this).data("instance-id"));
  });
};
